import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import createEventData from 'topmeteo/google-analytics/event';

import {showMatrix} from '../../actionCreators';

const ShowLabel = gettext('Show Product Matrix');
const HideLabel = gettext('Hide Product Matrix');

const eventData = (type, shown) => createEventData(
    type, 'click', shown ? 'Hide Product Matrix' : 'Show Product Matrix'
);

const MatrixToggle = ({type, shown, onClick}) => (
    <a className="struct-link matrix" onClick={onClick} {...eventData(type, shown)}>
        {shown ? HideLabel : ShowLabel}
    </a>
);

const mapDispatchToProps = (dispatch, {shown}) => ({
    onClick: () => dispatch(showMatrix(!shown)),
});

export default connect(null, mapDispatchToProps)(MatrixToggle);
